module.exports = __webpack_public_path__ + "assets/f66f670c62f08c206cf5da369e305a2a.png";